import { render } from "./MultipleChoice.vue?vue&type=template&id=d688283c&scoped=true&ts=true"
import script from "./MultipleChoice.vue?vue&type=script&lang=ts"
export * from "./MultipleChoice.vue?vue&type=script&lang=ts"

import "./MultipleChoice.vue?vue&type=style&index=0&id=d688283c&scoped=true&lang=scss"
import "./MultipleChoice.vue?vue&type=style&index=1&id=d688283c&lang=scss"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d688283c"]])

export default __exports__